export default {
  field: {
    label: 'Steuerkategorie',
    placeholder: 'Keine Steuerkategorie',
    unlinked_hint:
      'Ohne Auswahl gilt für ein Produkt die Steuerkategorie seiner Menükategorie, sonst der Standardsatz des Restaurants.',
    default_hint: 'Ohne Auswahl wird beim Speichern die Standard-Steuerkategorie des Menüs verwendet.',
  },
  empty: {
    hint: 'Noch keine Steuerkategorien — fügen Sie unten eine hinzu.',
    read_only_hint: 'Es wurden noch keine Steuerkategorien angelegt.',
  },
  option: {
    varies_by_channel: '(variiert je nach Bestellart)',
  },
  load_error: 'Steuerkategorien konnten nicht geladen werden — Verknüpfen und Trennen sind vorübergehend deaktiviert.',
  create: {
    name_placeholder: 'Name der neuen Kategorie',
    rate_placeholder: 'Satz %',
    button: 'Steuerkategorie hinzufügen',
  },
  toasts: {
    create_error: 'Die Steuerkategorie konnte nicht erstellt werden.',
  },
};
